<template>
    <div class="menu-container">
        <!-- <nav id="navbar" class="nav-bar" v-bind:class="[{'appTheme':colorTheme},{'companyTheme':!colorTheme}] "> -->
        <nav id="navbar" class="nav-bar" v-bind:class="[{'active':activated},{'nav-bar--light':this.sectionThemeDark},{' nav-bar--dark':!this.sectionThemeDark}]">

            <!-- <router-link to="/home#groupOfCompanies" ><div class="menu icon icon-back-button --tert"></div> </router-link> -->
                <!--<a href="/OurApps#OurMobileApps">-->
            <a onClick='window.history.go(-1)'>
                 <div class="menu icon icon-back-button"></div>
            </a>
            

        </nav>
        <div id="socialIconsWeb" class="social-icons-web">
            <ul class="social-items"
                v-bind:class="[
            {'light':this.socialIconsWebThemeDark},
            {'dark':!this.socialIconsWebThemeDark}
            ]">
                <li><a href="https://www.facebook.com/GlobalChoicesZA/" class="facebook" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://twitter.com/GlobalChoicesZA" class="twitter" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://www.linkedin.com/company/global-choices-lifestyle/?originalSubdomain=za" class="linkedin" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://www.instagram.com/globalchoicesza/" class="instagram" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://www.youtube.com/channel/UCbCW_LVHs3zhXqtY6yRETBQ" class="youtube" target="_blank" rel="noopener noreferrer"></a></li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name:"ReturnBackMenu",
    // props:["menuConfig","menuClass","sectionThemeDark","backgroundColor","scrolled","currentSectionID","scrollBarPos","scrollBarPosYoffset","sectionHeight","sectionEndPos"],
    // props:["colorTheme"],
    props:[],
    data(){
            return{
                activated:false,
                menuClass:'nav-bar--light',
                sectionThemeDark:true,
                backgroundColor:'#fff',
                scrolled: false,
                currentSectionID:0,
                scrollBarPos:0,
                scrollBarPosYoffset:0,
                sectionHeight:0,
                sectionEndPos:0,
                appTheme:true,
                socialIconsWebThemeDark:true
            }
        },
        methods:{
        markActive(){
        this.activated = !this.activated;
        // will try use this method to handle the opening and closing of the menu
        },
        handleScroll () {
            //this.scrolled = window.scrollY > 0;
            let scrolling = false;
            //function scrollCheck() {
            //    scrolling = true;
            //}
             setInterval( function() {
                if ( scrolling ) {
                    scrolling = false;

                }
            }, 250 );

            this.scrollBarPos = window.scrollY;
            // console.log("scrolled"+this.scrolled);
            //console.log("scrollBarPos"+this.scrollBarPos);

            let letCurrentSectionID=0;
            let letNextSectionID=0;
            //let myNewMenuClass = this.backgroundColor;
            let windowHeight = window.innerHeight;
            let iconTriggerPosition = windowHeight*0.9;
            //console.log("~~iconTriggerPosition"+iconTriggerPosition);

            //console.log("~~windowHeight"+windowHeight);
            const sections = document.querySelectorAll('.section');
                this.scrollBarPosYoffset = window.pageYOffset;


                let index = 0, length = sections.length;
                for (index; index < length; index++){

                    let sectionStartPos = sections[index].offsetTop;
                    //let sectionHeight = sections[index].offsetHeight;
                    //let sectionEndPos = sectionStartPos + sectionHeight;

                    if((sectionStartPos-30) <= this.scrollBarPos){
                        this.currentSectionID = index;
                        letCurrentSectionID = index;
                        // could possibly use more if statements here to trigger methods and change colours of seperate components.

                    }
                    if((sectionStartPos-iconTriggerPosition) <= this.scrollBarPos){
                        // this.currentSectionID = index;
                         letNextSectionID = index;

                        // could possibly use more if statements here to trigger methods and change colours of seperate components.
                        //console.log("letNextSectionID");
                        // console.log("+++"+sectionStartPos);
                         //console.log("$$$iconsText"+iconTriggerPosition);
                    }
                }
                //console.log("currentSectionID: "+letCurrentSectionID+" sections: "+sections);
                //  setMenuClass(currentSectionID,sections);

                this.setMenuClass(letCurrentSectionID,sections);
                this.setSocialIconClass(letNextSectionID,sections);
        },
        setMenuClass(sectionID,sections){

            //let nav = document.querySelector('#socialIconsWeb ul.social-items');
            //let themeColor = "";
            let ValSectionThemeDark = "";
            // themeColor = sections[sectionID].dataset.themecolor;  // get the themeColor of the data-set attribute
            ValSectionThemeDark = sections[sectionID].dataset.sectionthemedark;  // get the themeColor of the data-set attribute

            //console.log("*** sectionID: "+sectionID+" ValSectionThemeDark: "+ValSectionThemeDark);

            if(!ValSectionThemeDark){
                //console.log("ValSectionThemeDark:"+ValSectionThemeDark);
                //if no value, make menu default white.
                this.sectionThemeDark = true;
            }
            else if(ValSectionThemeDark=='true')
            {
               // console.log("ValSectionThemeDark:"+ValSectionThemeDark);
                this.sectionThemeDark = true;
                // console.log("ThisSectionThemeDark-true:"+this.sectionThemeDark);
            }else{
              this.sectionThemeDark = false;
                // console.log("ThisSectionThemeDark-false:"+this.sectionThemeDark);

            }

        },
        setSocialIconClass(nextSectionID,sections){

            //let nav = document.querySelector('#navbar');
            //let themeColor = "";
            let ValSocialIconsWebThemeDark = "";
            // themeColor = sections[sectionID].dataset.themecolor;  // get the themeColor of the data-set attribute
            ValSocialIconsWebThemeDark = sections[nextSectionID].dataset.sectionthemedark;  // get the themeColor of the data-set attribute
            //console.log("___ nextSectionID: "+nextSectionID+" ValSocialIconsWebThemeDark: "+ValSocialIconsWebThemeDark);
            if(!ValSocialIconsWebThemeDark){
                //console.log("ValSocialIconsWebThemeDark:"+ValSocialIconsWebThemeDark);
                //if no value, make menu default white.
                this.socialIconsWebThemeDark = true;
            }
            else if(ValSocialIconsWebThemeDark=='true')
            {
               // console.log("ValSocialIconsWebThemeDark:"+ValSocialIconsWebThemeDark);
                this.socialIconsWebThemeDark = true;
                // console.log("ThisSectionThemeDark-true:"+this.sectionThemeDark);
            }else{
              this.socialIconsWebThemeDark = false;
                // console.log("ThisSectionThemeDark-false:"+this.sectionThemeDark);

            }

        },
        goto(idName) {
            //var thisrefName = refName;
            const navLocation = document.getElementById(idName);

           // var element = $refs[thisrefName];
            // console.log("thisrefName id"+idName);
            //   console.log("navLocation"+navLocation);
             let top = navLocation.offsetTop;
            //let sectionStartPos = sections[index].offsetTop;
            //   console.log("top of height:"+top);

             window.scrollTo(0, top);
        }
    },
    created: function() {
       let scrolling = false;
        // attached listner to scrollActive, make scrolling true
        window.addEventListener('scroll', scrollActive);
        function scrollActive() {
            scrolling = true;
        }

        /*   on created. this continuesly goes off every 0.35sec, checks if the page is scrolling.
        if it is, trigger the handleScroll method.         */
        setInterval( ()=> {
            if ( scrolling ) {
                scrolling = false;
                this.handleScroll();
            }
        }, 350 );

    }
    // ,
    // destroyed: function() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // }
}
</script>

<style lang="scss" scoped>
    .appTheme {
        background-color: #575756;
        a

    {
        color: #ffffff;
    }

    }

    .companyTheme {
        background-color: #ffffff;
        a

    {
        color: #575756;
    }
    }
</style>